import React from "react";
import { useRoutes } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import DatasetPage from "./pages/DatasetPage";
import SectorPage from "./pages/SectorPage";
import QuestionPage from "./pages/QuestionPage";
import EthnicityPage from "./pages/EthnicityPage";
import LocationPage from "./pages/LocationPage";
import LoadingPage from "./pages/LoadingPage";
import ResultPage from "./pages/ResultPage";
import ErrorPage from "./pages/ErrorPage";
import { PersonaProvider } from "./context/PersonaContext";
import ParallelFlowRouter from "./routes/ParallelFlowRouter";
import UploadContactPage from "./pages/UploadContactPage";

const App = () => {
  const routes = useRoutes([
    { path: "/", element: <LandingPage /> },
    { path: "dataset", element: <DatasetPage /> },
    { path: "sectors", element: <SectorPage /> },
    { path: "questions", element: <QuestionPage /> },
    { path: "ethnicity", element: <EthnicityPage /> },
    { path: "location", element: <LocationPage /> },
    { path: "loading", element: <LoadingPage /> },
    { path: "result", element: <ResultPage /> },
    { path: "*", element: <ErrorPage /> },
    { path: "/parallel/*", element: <ParallelFlowRouter /> },
    { path: "/upload", element: <UploadContactPage /> },
  ]);

  return <PersonaProvider>{routes}</PersonaProvider>;
};

export default App;
